import { cx } from 'class-variance-authority';
import { ReactNode } from 'react';
import { LayoutBuilderTypeFull } from '@shared/types/process';

export const BlockViewCard = ({
    block,
    ChildrenContext,
    isParent,
    childrenBtnForFlowTab,
}: {
    block: LayoutBuilderTypeFull;
    ChildrenContext: ReactNode;
    isParent?: boolean;
    childrenBtnForFlowTab?: React.ReactNode;
}) => {
    if (block.type !== 'Card') return null;

    return (
        <div
            css={{ width: '100%', height: '100%' }}
            className={cx(
                `bg-transparent`,
                isParent && 'flex flex-col gap-4 p-5',
            )}
        >
            {ChildrenContext}

            {isParent && childrenBtnForFlowTab}
        </div>
    );
};
